import $ from 'jquery'

const FORM_REVEAL_DELAY = 10000

$(document).ready(function () {
  initPastWebinarsLoadMore()
  initPastWebinarsModal()
  initPastWebinarHubSpotFormSuccess()
})

function initPastWebinarsLoadMore() {
  $('.dhsv_vc_past_webinars').each(function () {
    const $module = $(this)
    const $list = $module.find('.past-webinars__list')
    const $loadMoreBtn = $module.find('.past-webinars__load-more')

    if (!$list.length || !$loadMoreBtn.length) {
      return
    }

    const displayCount = parseInt($module.data('display-count'), 10) || 9

    if (!$list.find('.past-webinars__card--hidden').length) {
      return
    }

    $loadMoreBtn.on('click', function () {
      const $currentlyHidden = $list.find('.past-webinars__card--hidden')
      const toReveal = $currentlyHidden.slice(0, displayCount)
      toReveal.removeClass('past-webinars__card--hidden')

      if (!$list.find('.past-webinars__card--hidden').length) {
        $loadMoreBtn.closest('.past-webinars__footer').hide()
      }
    })
  })
}

function initPastWebinarsModal() {
  $('.dhsv_vc_past_webinars').each(function () {
    const $module = $(this)

    $module.on('click', '.past-webinars__btn[data-modal-target]', function (
      event
    ) {
      event.preventDefault()
      const modalId = $(this).data('modal-target')
      const $modal = $module.find('#' + modalId).length
        ? $module.find('#' + modalId)
        : $('#' + modalId)

      if ($modal.length) {
        openPastWebinarModal($modal)
      }
    })
  })

  $(document).on('click.pastWebinarsModal', '[data-modal-close]', function (
    event
  ) {
    event.preventDefault()
    const $modal = $(this).closest('.past-webinars__modal')
    closePastWebinarModal($modal)
  })

  $(document).on('keydown.pastWebinarsModal', function (event) {
    if (event.key === 'Escape') {
      $('.past-webinars__modal.is-open').each(function () {
        closePastWebinarModal($(this))
      })
    }
  })
}

function openPastWebinarModal($modal) {
  const $iframe = $modal.find('.past-webinars__video-frame')
  const $formWrapper = $modal.find('.past-webinars__form-wrapper')

  portalPastWebinarModal($modal)
  clearPastWebinarTimer($modal)
  $modal.addClass('is-open').attr('aria-hidden', 'false')
  $('body').addClass('past-webinars-modal-open')

  if ($formWrapper.length) {
    $formWrapper.attr('hidden', 'hidden')
  }

  setPastWebinarIframeSrc($iframe, getPastWebinarIframeSrc($iframe))
  $modal.data('videoStartedAt', Date.now())

  if ($formWrapper.length) {
    const timerId = window.setTimeout(() => {
      showPastWebinarForm($modal)
    }, FORM_REVEAL_DELAY)
    $modal.data('pastWebinarTimer', timerId)
    bindPastWebinarFormObserver($modal)
  }
}

function closePastWebinarModal($modal) {
  if (!$modal.length) {
    return
  }

  clearPastWebinarTimer($modal)
  $modal.removeClass('is-open is-form-visible').attr('aria-hidden', 'true')

  const $iframe = $modal.find('.past-webinars__video-frame')
  setPastWebinarIframeSrc($iframe, 'about:blank')
  $iframe.removeData('resumeAt')
  $modal.removeData('videoStartedAt')

  const $formWrapper = $modal.find('.past-webinars__form-wrapper')
  if ($formWrapper.length) {
    $formWrapper.attr('hidden', 'hidden')
  }

  $('body').removeClass('past-webinars-modal-open')
  restorePastWebinarModal($modal)
}

function showPastWebinarForm($modal) {
  const $formWrapper = $modal.find('.past-webinars__form-wrapper')
  const $iframe = $modal.find('.past-webinars__video-frame')

  if (!$formWrapper.length) {
    return
  }

  const startedAt = $modal.data('videoStartedAt')
  const resumeAt =
    typeof startedAt === 'number'
      ? Math.max(0, Math.floor((Date.now() - startedAt) / 1000))
      : Math.floor(FORM_REVEAL_DELAY / 1000)
  $iframe.data('resumeAt', resumeAt)
  setPastWebinarIframeSrc($iframe, 'about:blank')

  $formWrapper.removeAttr('hidden')
  $modal.addClass('is-form-visible')
}

function hidePastWebinarForm($modal) {
  const $formWrapper = $modal.find('.past-webinars__form-wrapper')
  const $iframe = $modal.find('.past-webinars__video-frame')

  if ($formWrapper.length) {
    $formWrapper.attr('hidden', 'hidden')
  }

  $modal.removeClass('is-form-visible')

  const resumeAt = $iframe.data('resumeAt') || 0
  const src = getPastWebinarIframeSrc($iframe)
  setPastWebinarIframeSrc($iframe, appendVideoStartTime(src, resumeAt))
}

function bindPastWebinarFormObserver($modal) {
  const $formWrapper = $modal.find('.past-webinars__form-wrapper')

  if (!$formWrapper.length || $formWrapper.data('observerAttached')) {
    return
  }

  const observer = new MutationObserver(() => {
    if ($formWrapper.find('.submitted-message').length) {
      if (PAST_WEBINAR_DEBUG)
        console.log(
          '[pastWebinar] MutationObserver: .submitted-message found, calling onPastWebinarFormSubmitted'
        )
      onPastWebinarFormSubmitted($modal)
    }
  })

  observer.observe($formWrapper.get(0), { childList: true, subtree: true })
  $formWrapper.data('observerAttached', true)
  $formWrapper.data('observer', observer)
}

const PAST_WEBINAR_DEBUG = true

/**
 * Ensure hbspt.forms.create is patched to dispatch pastWebinarFormSubmitted on submit.
 * Call when HubSpot might already be loaded (e.g. script in head).
 */
function patchHubspotFormsCreateIfNeeded() {
  try {
    const hbspt = window.hbspt
    if (
      !hbspt ||
      !hbspt.forms ||
      !hbspt.forms.create ||
      hbspt.forms.create._pastWebinarPatched
    ) {
      if (PAST_WEBINAR_DEBUG) {
        console.log('[pastWebinar] patchHubspotFormsCreateIfNeeded: skip', {
          hasHbspt: !!hbspt,
          hasForms: !!(hbspt && hbspt.forms),
          hasCreate: !!(hbspt && hbspt.forms && hbspt.forms.create),
          alreadyPatched: !!(
            hbspt &&
            hbspt.forms &&
            hbspt.forms.create &&
            hbspt.forms.create._pastWebinarPatched
          ),
        })
      }
      return
    }
    const orig = hbspt.forms.create
    hbspt.forms.create = function (opts) {
      opts = opts || {}
      const origCb = opts.onFormSubmitted
      opts.onFormSubmitted = function () {
        if (PAST_WEBINAR_DEBUG)
          console.log(
            '[pastWebinar] onFormSubmitted (from bundle patch), dispatching event'
          )
        if (typeof origCb === 'function') origCb.apply(this, arguments)
        window.dispatchEvent(new CustomEvent('pastWebinarFormSubmitted'))
      }
      return orig.call(this, opts)
    }
    hbspt.forms.create._pastWebinarPatched = true
    if (PAST_WEBINAR_DEBUG)
      console.log('[pastWebinar] patchHubspotFormsCreateIfNeeded: patched')
  } catch (e) {
    if (PAST_WEBINAR_DEBUG)
      console.warn('[pastWebinar] patchHubspotFormsCreateIfNeeded error', e)
  }
}

/**
 * Listen for HubSpot form submission:
 * 1) Custom event from hbspt.forms.create() callback (embed script / v2)
 * 2) postMessage (form in iframe)
 * On success: hide form, resume video, then close the modal.
 */
function initPastWebinarHubSpotFormSuccess() {
  if (PAST_WEBINAR_DEBUG)
    console.log('[pastWebinar] initPastWebinarHubSpotFormSuccess')
  patchHubspotFormsCreateIfNeeded()

  window.addEventListener('pastWebinarFormSubmitted', function () {
    if (PAST_WEBINAR_DEBUG)
      console.log('[pastWebinar] pastWebinarFormSubmitted event received')
    const $modal = $('.past-webinars__modal.is-open')
    if (PAST_WEBINAR_DEBUG)
      console.log('[pastWebinar] open modal count:', $modal.length)
    if ($modal.length) {
      onPastWebinarFormSubmitted($modal)
    } else if (PAST_WEBINAR_DEBUG) {
      console.warn('[pastWebinar] no .past-webinars__modal.is-open found')
    }
  })

  window.addEventListener('message', function (event) {
    const data = event.data
    if (
      PAST_WEBINAR_DEBUG &&
      data &&
      (data.type === 'hsFormCallback' ||
        (typeof data === 'object' && 'type' in data))
    ) {
      console.log('[pastWebinar] message', data.type, data.eventName || data)
    }
    if (
      !data ||
      data.type !== 'hsFormCallback' ||
      data.eventName !== 'onFormSubmitted'
    ) {
      return
    }
    if (PAST_WEBINAR_DEBUG)
      console.log(
        '[pastWebinar] hsFormCallback onFormSubmitted from postMessage'
      )
    let $modal = findPastWebinarModalByMessageSource(event.source)
    if (!$modal.length) {
      $modal = $('.past-webinars__modal.is-open')
    }
    if ($modal.length) {
      onPastWebinarFormSubmitted($modal)
    } else if (PAST_WEBINAR_DEBUG) {
      console.warn(
        '[pastWebinar] postMessage: no modal found (by source or open)'
      )
    }
  })
}

function findPastWebinarModalByMessageSource(sourceWindow) {
  const $openModals = $('.past-webinars__modal.is-open')
  for (let i = 0; i < $openModals.length; i++) {
    const $modal = $openModals.eq(i)
    const $formWrapper = $modal.find('.past-webinars__form-wrapper')
    if (!$formWrapper.length) continue
    const $iframe = $formWrapper.find('iframe')
    for (let j = 0; j < $iframe.length; j++) {
      try {
        if ($iframe[j].contentWindow === sourceWindow) {
          return $modal
        }
      } catch (_) {
        // cross-origin: ignore
      }
    }
  }
  return $()
}

/**
 * Called when the webinar gate form is successfully submitted (inline or iframe).
 * Hides the form and resumes the video; the modal stays open so the user can keep watching.
 */
function onPastWebinarFormSubmitted($modal) {
  if (PAST_WEBINAR_DEBUG)
    console.log(
      '[pastWebinar] onPastWebinarFormSubmitted called',
      $modal.length,
      $modal.attr('id')
    )
  if (!$modal.length) return
  hidePastWebinarForm($modal)
  if (PAST_WEBINAR_DEBUG)
    console.log('[pastWebinar] form hidden, video resumed')
}

function clearPastWebinarTimer($modal) {
  const timerId = $modal.data('pastWebinarTimer')
  if (timerId) {
    window.clearTimeout(timerId)
    $modal.removeData('pastWebinarTimer')
  }
}

function getPastWebinarIframeSrc($iframe) {
  return $iframe.data('video-src') || $iframe.attr('src') || ''
}

function setPastWebinarIframeSrc($iframe, src) {
  if ($iframe.length) {
    $iframe.attr('src', src)
  }
}

function appendVideoStartTime(src, seconds) {
  if (!src || !seconds) {
    return src
  }

  const base = src.split('#')[0]
  return `${base}#t=${seconds}`
}

function portalPastWebinarModal($modal) {
  if (!$modal.length || $modal.data('portalAttached')) {
    return
  }

  $modal.data('portalParent', $modal.parent())
  $modal.data('portalNext', $modal.next())
  $('body').append($modal)
  $modal.data('portalAttached', true)
}

function restorePastWebinarModal($modal) {
  if (!$modal.length || !$modal.data('portalAttached')) {
    return
  }

  const $parent = $modal.data('portalParent')
  const $next = $modal.data('portalNext')

  if ($next && $next.length) {
    $next.before($modal)
  } else if ($parent && $parent.length) {
    $parent.append($modal)
  }

  $modal.removeData('portalAttached portalParent portalNext')
}
